import NestedForm from "stimulus-rails-nested-form";

export default class extends NestedForm {
  static targets = [...NestedForm.targets, "addButton"];
  static values = {
    ...NestedForm.values,
    minItems: {
      type: Number,
      default: 1,
    },
    maxItems: {
      type: Number,
      default: null,
    },
  };

  connect() {
    super.connect();
    this.updateDeleteButtons();
    this.updateAddButton();
    // Listen for turbo events to update buttons after form re-renders
    document.addEventListener("turbo:render", this.updateAllButtons.bind(this));
  }

  disconnect() {
    super.disconnect();
    document.removeEventListener(
      "turbo:render",
      this.updateAllButtons.bind(this),
    );
  }

  add(e) {
    super.add(e);
    // Update buttons after adding
    setTimeout(() => this.updateAllButtons(), 0);
  }

  remove(e) {
    super.remove(e);
    // Update buttons after removing
    setTimeout(() => this.updateAllButtons(), 0);
  }

  updateAllButtons() {
    this.updateDeleteButtons();
    this.updateAddButton();
  }

  updateDeleteButtons() {
    const wrappers = this.element.querySelectorAll(
      this.wrapperSelectorValue + ':not([style*="display: none"])',
    );
    wrappers.forEach((wrapper, index) => {
      // FIRST: Remove ALL existing delete buttons (including Rails-generated ones)
      const existingDeleteButtons = wrapper.querySelectorAll(
        'a[data-action*="extended-nested-form#remove"], a[data-action*="remove"]',
      );
      existingDeleteButtons.forEach((button) => {
        const parentSpan = button.closest('span[style*="position:absolute"]');
        if (parentSpan) {
          parentSpan.remove();
        } else {
          button.remove();
        }
      });
      // Remove our custom containers too
      const deleteContainers = wrapper.querySelectorAll(
        ".delete-button-container",
      );
      deleteContainers.forEach((container) => container.remove());
      // THEN: Add delete button only where needed
      if (index >= this.minItemsValue) {
        const deleteContainer = this.createDeleteButton();
        // Find the best place to insert it (last element with position-relative)
        const positionRelativeElement =
          wrapper.querySelector(".position-relative");
        if (positionRelativeElement) {
          positionRelativeElement.appendChild(deleteContainer);
        } else {
          // Fallback: append to the wrapper
          wrapper.appendChild(deleteContainer);
        }
      }
    });
  }

  createDeleteButton() {
    const container = document.createElement("span");
    // Use inline styles exactly like the design
    container.style.cssText = "position:absolute;top:10px;right:-22px";
    const link = document.createElement("a");
    link.href = "#";
    link.dataset.action = "extended-nested-form#remove";
    const icon = document.createElement("i");
    icon.className = "bi bi-trash3-fill text-danger";
    link.appendChild(icon);
    container.appendChild(link);
    return container;
  }

  updateAddButton() {
    if (!this.hasAddButtonTarget) return;

    const activeWrappers = this.element.querySelectorAll(
      this.wrapperSelectorValue + ':not([style*="display: none"])',
    );
    const currentCount = activeWrappers.length;
    // If no maxItems is set, don't modify the button
    if (this.maxItemsValue === null) return;

    const remainingSlots = this.maxItemsValue - currentCount;
    if (remainingSlots <= 0) {
      // Hide the add button completely
      this.addButtonTarget.style.display = "none";
    } else {
      // Show the button and update the text
      this.addButtonTarget.style.display = "";
      // Find the link inside the add button target and update its text
      const addLink = this.addButtonTarget.querySelector(
        'a[data-action*="extended-nested-form#add"]',
      );
      if (addLink) {
        const baseText =
          addLink.dataset.baseText || this.extractBaseText(addLink.textContent);
        addLink.dataset.baseText = baseText; // Store original text for future updates
        if (remainingSlots === 1) {
          addLink.textContent = `${baseText} (nog ${remainingSlots})`;
        } else {
          addLink.textContent = `${baseText} (nog ${remainingSlots})`;
        }
      }
    }
  }

  extractBaseText(fullText) {
    return fullText.replace(/\s*\(nog\s+\d+\)\s*$/, "").trim();
  }
}
